import { PhoneNumberUtil } from 'google-libphonenumber';

export const getCountryCodeFromRegionCode = (regionCode: string) => {
	const phoneNumberUtil = new PhoneNumberUtil();
	return phoneNumberUtil.getCountryCodeForRegion(regionCode);
};
